<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Dropdown</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>

<div class="content">
  <h1>Dropdown Without Label Component</h1>
  <maced-dropdown-without-label id="dropdownId" [dropdownOptions]="dropdownOptions" placeholderLabel="Select Language"
    [(ngModel)]="language">
  </maced-dropdown-without-label>
  Selected:- {{ language }}

  <br><br>

  <form [formGroup]="dropdownForm">
    <label class="c-input-group__label">Sample Label</label>
    <maced-dropdown-without-label id="dropdownId2" [dropdownOptions]="dropdownOptions"
      placeholderLabel="Select Language" formControlName="language">
    </maced-dropdown-without-label>
  </form>

  Selected:- {{ dropdownForm.value.language }}
</div>

<div class="content">
  <h2>No JS</h2>

  <form action="/dropdown-without-label" method="get">
    <maced-dropdown-without-label id="dropdownId3" [dropdownOptions]="dropdownOptions"
      placeholderLabel="Select Language" name="language" [value]="inputNgModelNojs">
    </maced-dropdown-without-label>
    <maced-button buttonId="submit3" label="Submit" buttonType="submit"></maced-button>
  </form>
  <div>
    <h3>Result</h3>
    <div>
      Input value:-&nbsp;
      {{ inputNgModelNojs }}
    </div>
  </div>
</div>